import script from "./CreateUpdateGroupsUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateUpdateGroupsUsers.vue?vue&type=script&setup=true&lang=js"

import "./CreateUpdateGroupsUsers.vue?vue&type=style&index=0&id=5e79dc22&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e79dc22"]])

export default __exports__